<template>
  <div>
    <b-form>
      <h1>Add a Location</h1>
      <b-form-group horizontal label="Name:" label-size="lg">
        <!-- <label for="txtLocationName">Name:</label> -->
        <b-form-input type="text" v-model="newLocation.name"></b-form-input>
      </b-form-group>
      <b-form-group horizontal label="Survey Date:" label-size="lg">
        <b-form-input type="date" v-model="newLocation.surveyDate"></b-form-input>
      </b-form-group>
      <b-form-group horizontal label="Pass Code:" label-size="lg">
        <b-form-input type="text" v-model="newLocation.passCode"></b-form-input>
      </b-form-group>
      <div>
        <b-button variant="primary" size="lg" @click="save">Save</b-button>&nbsp;
        <b-button size="lg" to="/locations" tag="button">Back</b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
//import { required } from "vuelidate/lib/validators";
import ajax from "@/resources/myApi.js";

export default {
  name: "addLocation",
  data: () => ({
    newLocation: {
      name: null,
      dateCreated: new Date().toISOString().slice(0,10),
      surveyDate: new Date().toISOString().slice(0,10),
      passCode: ""
    }
  }),
  //  validations: {
  //   newLocation.name: {
  //     required
  //   },

  // },
  methods: {
    save() {
      ajax
          .post("locations/add", this.newLocation)
          .then(() =>
            this.$router.push({
              name: "locations"
            })
          )
          .catch(error => console.log(error));
    }
  }
};
</script>
